<template>
    <div class="enterprise-upgrade">
        <div class="content-box first">
            <TitleTip>您所填写的信息将会提供给电子签进行企业认证校验、存证，用于后续的签署合同、授权合约等</TitleTip>
            <div class="user-info">您（{{ $store.state.userInfo.name }}，{{ $store.state.userInfo.userIdNum }}），将为您的企业进行认证并签署合同</div>
        </div>
        <div class="content-box row">
            <div class="name">
                <h1>我是法定代表人</h1>
                <p>仅需两步即可升级到企业账号</p>
            </div>
            <div class="content">
                <p>
                    <span class="enterprises-select"></span>
                    营业执照原件的高清图片
                </p>
                <p>
                    <span class="enterprises-select"></span>
                    手机号验证
                </p>
            </div>
            <div class="operation">
                <el-button type="primary" :loading="loading" @click="startUpgrade(1)">升级并认证</el-button>
            </div>
        </div>
        <div class="content-box row">
            <div class="name">
                <h1>我不是法定代表人</h1>
                <p>以企业代理人的方式进行认证</p>
            </div>
            <div class="content">
                <p>
                    <span class="enterprises-select"></span>
                    营业执照原件的高清图片
                </p>
                <p>
                    <span class="enterprises-select"></span>
                    对公账户及开户行信息
                </p>
                <p>
                    <span class="enterprises-select"></span>
                    内有授权书模板，请下载
                    <b>并加盖公章</b>
                </p>
            </div>
            <div class="operation">
                <el-button type="primary" :loading="loading" @click="startUpgrade(2)">升级并认证</el-button>
            </div>
        </div>
        <div class="content-box row">
            <div class="name">
                <h1>我是个体工商户</h1>
            </div>
            <div class="content">
                <p>
                    <span class="enterprises-select"></span>
                    营业执照原件的高清图片
                </p>
                <p>
                    <span class="enterprises-select"></span>
                    个体工商户只能本人进行认证操作
                </p>
            </div>
            <div class="operation">
                <el-button type="primary" :loading="loading" @click="startUpgrade(3)">升级并认证</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import {enterprise} from '@/api/user';
export default {
    components: {},
    data() {
        return {
            loading: false,
        };
    },
    mounted() {
        this.goStep();
    },
    methods: {
        async goStep() {
            await this.$store.dispatch('getEnterpriseCertify', true);
            const {enterpriseUpgradeStep, enterpriseUpgradeType} = this.$store.getters;
            if (!enterpriseUpgradeStep.step && enterpriseUpgradeType == 0) return false;
            this.$router.replace({path: '/manage/contract/enterprise/dzq/authentication'});
        },
        async startUpgrade(upgradeAuthType) {
            this.loading = true;
            const response = await enterprise(upgradeAuthType);
            const {state, msg} = response.data;
            this.loading = false;
            if (!state) return this.$message.error(msg || '操作失败，请稍后尝试。');
            this.$router.push({path: '/manage/contract/enterprise/dzq/authentication'});
        },
    },
};
</script>
<style lang="scss" scoped>
.enterprise-upgrade {
    .user-info {
        padding: 20px 0px 0px;
        font-weight: 400;
        color: $--color-font-normal;
        line-height: 14px;
    }

    .row {
        display: flex;
        margin: 20px 0 0;
        border-radius: 6px;
        padding: 74px 40px;
        justify-content: space-between;
        align-items: center;

        p {
            color: $--color-font-text;
            line-height: 12px;
        }

        .name {
            width: 30%;

            h1 {
                font-weight: 400;
                color: $--color-font-normal;
                line-height: 24px;
                margin-bottom: 16px;
                font-size: 24px;
            }
        }

        .content {
            width: 40%;

            p {
                margin: 16px 0;

                .enterprises-select {
                    background: url('~@/assets/img/enterprises/enterprises-select.svg') no-repeat center;
                    width: 12px;
                    height: 12px;
                    float: left;
                    font-size: 12px;
                    margin-right: 6px;
                }

                b {
                    color: $--color-font-normal;
                }
            }
        }
    }
}
</style>
